export const DISCOUNT_TYPE_PERCENT = 1;
export const DISCOUNT_TYPE_SUM = 2;